import React from 'react';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';
import TrackVisibility from 'react-on-screen';


const AboutFour = () => {
    return (
            <div className="section section-padding case-study-featured-area">
                <div className="container">
                    <div className="row">
                    <div className="col-xl-7 col-lg-6">
                        <div className="case-study-featured-thumb text-start">
                        <img src={ "/images/others/about-new.png"} alt="travel" />
                        </div>
                    </div>
                    <div className="col-xl-5 col-lg-6">
                        <div className="case-study-featured">
                        <div className="section-heading heading-left">
                            <span className="subtitle">About Us</span>
                            {/* <h2 className="title">Building software for world changers</h2> */}
                           <p>Welcome to Graphify Infotech! We're a dynamic and innovative company specializing in bringing your digital vision to life.
With a dedicated team of 10–15 passionate experts, we offer comprehensive solutions to elevate your online presence and drive business growth.</p>

<p>At Graphify Infotech, we excel in web and mobile app development, crafting bespoke, user-friendly, and high-performing digital experiences tailored to your unique needs.</p>

<p>Beyond development, our robust digital marketing services encompass everything you need to stand out in a crowded marketplace. We're masters of SEO, ensuring your brand ranks high and is easily discoverable.</p><p> Our social media management strategies build engaging communities around your brand, while our expert branding services forge a strong, memorable identity that resonates with your audience.</p>
                              {/* <Link to="#" className="axil-btn btn-fill-primary btn-large">Read More</Link> */}
                        </div>
                        {/* <div className="case-study-counterup">
                            <div className="single-counterup">
                            <h2 className="count-number">
                            <TrackVisibility once>
                                {({isVisible}) => (
                                    <span className="number count">
                                        {isVisible ? <CountUp end="10" duration={1} /> : null}
                                    </span>
                                )}  
                            </TrackVisibility>
                            <span className="symbol">+</span>
                            </h2>
                            <span className="counter-title">Years on the market</span>
                            </div>
                            <div className="single-counterup">
                            <h2 className="count-number">
                            <TrackVisibility once>
                                {({isVisible}) => (
                                    <span className="number count">
                                        {isVisible ? <CountUp end="1500" duration={1} /> : null}
                                    </span>
                                )}  
                            </TrackVisibility>
                            <span className="symbol">+</span>
                            </h2>
                            <span className="counter-title">Projects delivered so far</span>
                            </div>
                        </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default AboutFour;